var React = require('react');
var DefaultLayout = require('./common/layout');
import { Form, FormGroup, Col, ControlLabel, Button } from 'react-bootstrap';
import { CenteredDiv } from './common/basic';
import { FControl, CheckBox } from './common/forms';
import '../public/less/login.less';
import axios from 'axios';

const loginForm = class Devices extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isPasswordSent: false,
      PhoneNumber: this.props.location.query.phone ? this.props.location.query.phone : '',
      Email: this.props.location.query.email ? this.props.location.query.email : '',
      isError: this.props.location.query.m ? true : false,
      errorType: ""
    }

    this.updateEmail = this.updateEmail.bind(this);
    this.updatePhoneNumber = this.updatePhoneNumber.bind(this);
    this.sendOTP = this.sendOTP.bind(this);
    this.submitForm = this.submitForm.bind(this);
  }

  updateEmail(evt) {
    this.setState({ Email: evt.target.value });
  }

  updatePhoneNumber(evt) {
    this.setState({ PhoneNumber: evt.target.value });
  }

  sendOTP() {
    axios
      .post("/SendOTP", {
        PhoneNumber: this.state.PhoneNumber,
        Email: this.state.Email
      })
      .then(function (data) {
        this.setState({ isPasswordSent: true, isError: false });
      }.bind(this))
      .catch(function (error) {
        this.setState({ isError: true, wrongEmailOrPass: "wrongEmailOrPass" });
      }.bind(this));
  }

  submitForm(evt) {
    if (this.state.isPasswordSent) {
      this
        ._submit
        .click();
    }
    else {
      evt.preventDefault();
      this.sendOTP();
    }
  }

  render() {
    var errorMsg = "";
    if (this.state.isError && (this.props.location.query.m == "wrongEmailOrPass" || this.state.wrongEmailOrPass == "wrongEmailOrPass"))
      errorMsg = "Email or phone number don't exist.";
    else if (this.state.isError && this.props.location.query.m == "wrongCode")
      errorMsg = "Wrong code, please try again.";


    var codeClass = "";
    if (!this.state.isPasswordSent)
      codeClass = "hidden";


    return (
      <div className='loginBackground'>
        <div className='loginContainer'>
          <Form horizontal method="post" autoComplete="off" onSubmit={this.submitForm}>
            <div className='loginHeader'>
              <div className='loginLogo'></div>
              <h3 style={{ margin: '80px 40px 0px 110px' }}>Forgot Password</h3>
              <div className='loginFormContainer' style={{ marginTop: '110px' }}>

                <FormGroup>
                  <input type="email" placeholder="Email" name="Email" id="Email" className="form-control" autoComplete="new-password" onChange={this.updateEmail} value={this.state.Email} />
                </FormGroup>

                <FormGroup>
                  <input type="text" placeholder="Phone number" name="PhoneNumber" id="PhoneNumber" className="form-control" autoComplete="new-password" onChange={this.updatePhoneNumber} value={this.state.PhoneNumber} />
                </FormGroup>

                <FormGroup className={codeClass}>
                  <input type="text" placeholder="Code" name="Code" id="Code" className="form-control" autoComplete="new-password" />
                </FormGroup>

                <FormGroup>
                  <label className="error">{errorMsg}</label>
                </FormGroup>
              </div>
            </div>
            <input
              type='submit'
              className='hidden'
              ref={(submit) => {
                this._submit = submit;
              }} />
            <label className='submit' onClick={this.submitForm}>RESET</label>
          </Form>
        </div>
      </div>
    )
  }
};

module.exports = loginForm;


// WEBPACK FOOTER //
// ./modules/forgotPassword.jsx